<template>
    <div class="column  full-height">
        <div class="col-11 ">
            <q-scroll-area class="full-height">
                <q-list bordered padding>
                    <q-item>
                        <q-item-section>
                            <q-checkbox label="Выбрать все на проекте" dense
                                :model-value="selectedMainTasks.includes(-1)"
                                @update:model-value="v => selectAllProjectTasks(v)" />
                        </q-item-section>
                    </q-item>
                    <q-item>
                        <q-item-section>
                            <q-checkbox label="Выбрать все на странице" :true-value="2" :false-value="0" dense
                                :indeterminate-value="1"
                                :model-value="checkboxValue(selectedMainTasks.length, tasks.length)"
                                @update:model-value="v => selectAllTasks(v)" />
                        </q-item-section>
                    </q-item>
                    <q-item v-if="isLoading" v-for="i in 20">
                        <q-item-section avatar>
                            <q-skeleton type="rect" width="100%" />
                        </q-item-section>
                        <q-item-section>
                            <q-item-label>
                                <q-skeleton type="text" width="35%" />
                            </q-item-label>
                            <q-item-label caption>
                                <q-skeleton type="text" />
                            </q-item-label>
                        </q-item-section>
                    </q-item>
                    <q-expansion-item :model-value="taskId === task?.id"
                        :to="`/projects/${project}/tasks/${task.id}?page=${page}`" expand-separator v-for="task in tasks"
                        :caption="task.code" :label="task.name" :key="task.id">
                        <template v-slot:header>
                            <q-item-section avatar
                                v-if="!selectedMainTasks.includes(task.id)">
                                <q-icon :name="task.status === 'CLOSED' ? 'close' : 'pending'"
                                    :color="stateColors[task.state]" @click.prevent="addTask(task)">
                                    <q-tooltip>
                                        {{ status[task.status] }} - {{ states[task.state] }}
                                    </q-tooltip>
                                </q-icon>
                            </q-item-section>
                            <q-item-section avatar v-else>
                                <q-checkbox dense
                                    :model-value="selectedMainTasks.includes(task.id)"
                                    @update:model-value="removeTasks(task)" />
                            </q-item-section>
                            <q-item-section>
                                <q-item-label>{{ task.name }}</q-item-label>
                                <q-item-label caption>{{ task.code }}</q-item-label>
                            </q-item-section>

                        </template>
                        <q-list padding>
                            <q-item :inset-level="0.5" clickable v-ripple v-for="performTask in task.performTasks"
                                :to="`/projects/${project}/tasks/${task.id}/perform/${performTask.id}`">
                                <q-item-section avatar>
                                    <q-icon :name="performTask.status === 'CLOSED' ? 'close' : 'pending'"
                                        :color="stateColors[performTask.state]">
                                        <q-tooltip>
                                            {{ status[performTask.status] }} - {{ states[performTask.state] }}
                                        </q-tooltip>
                                    </q-icon>
                                </q-item-section>
                                <q-item-section>
                                    <q-item-label v-if="performTask.startTime">{{
                                        dayjs.utc(performTask.startTime).local().format('L LT')
                                    }} - {{ dayjs.utc(performTask.executionTime).local().format('L LT') }}
                                    </q-item-label>
                                    <q-item-label v-else>
                                        {{ dayjs.utc(performTask.executionTime).local().format('L LT') }}
                                    </q-item-label>
                                </q-item-section>
                            </q-item>
                        </q-list>
                    </q-expansion-item>
                    <q-item-section>
                    </q-item-section>
                </q-list>
            </q-scroll-area>

        </div>
        <div class="col-1 self-center" v-if="isReady">
            <q-pagination :max="maxPages" v-model="page" input input-class="text-primary" />
        </div>
    </div>
</template>

<script setup lang="ts">
import { useDayJs } from "../composables/dayjs";
import { stateColors, states, status } from "../util/state";
import { useTaskStore } from "../store/task";
import { storeToRefs } from "pinia";
import { useRoute } from "vue-router";
import { useRouteParams, useRouteQuery } from "@vueuse/router";
import { computed, reactive } from "vue";
import { Task } from "../models/task";
import {useEventBus} from "@vueuse/core";
import {taskKey} from "../util/events";

const { project } = defineProps<{
    project: number
}>()

const route = useRoute()

const selectedMainTasksSet = reactive<Set<number>>(new Set());

const selectedTasks = computed(() => [...selectedTasksSet]);

const selectedMainTasks = computed(() => [...selectedMainTasksSet]);

defineExpose({ selectedTasks, selectedMainTasks })

const taskId = useRouteParams('taskId', undefined, { transform: Number })

const page = useRouteQuery('page', '1', { transform: Number })

const dayjs = useDayJs()
const store = useTaskStore()
const { tasks, maxPages, isReady, isLoading } = storeToRefs(store)


function checkboxValue(actual: number, expected: number) {
    if (actual === 0) {
        return 0;
    } else if (actual === expected) {
        return 2;
    } else {
        return 1;
    }
}

function addTask(task: Task) {
    selectedMainTasksSet.add(task.id)
}
function removeTasks(task: Task) {
    selectedMainTasksSet.delete(task.id)

}

function selectAllTasks(v: number) {
    if (v == 2) {
        for (const task of tasks.value) {
            addTask(task)
        }
    } else {
        removeAllTasks()
    }
}

function selectAllProjectTasks(v: boolean) {
    if (v) {
        selectedMainTasksSet.add(-1)

    } else {
        selectedMainTasksSet.delete(-1)

    }
}

function removeAllTasks() {
    for (const task of tasks.value) {
        removeTasks(task)
    }
}

const taskEvent = useEventBus(taskKey)
taskEvent.on((event: string) => {
  if (event === 'refresh') {
    removeAllTasks()
  }
})
</script>

<style scoped></style>